<template>
    <div class="third">
        <el-form ref="formData" :model="formData" label-width="130px">
            <div class="title">三、术后服务支持</div>
            <div class="timeForm">
                <el-form-item label="日期">
                    <el-date-picker :disabled="thirdDisabled" v-model="formData.postoperativeDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择入院日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker :disabled="thirdDisabled" v-model="formData.postoperativeTime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="请选择入观时间"></el-date-picker>
                </el-form-item>
            </div>
            <el-form-item label="1.心理护理：">
                <el-checkbox-group :disabled="thirdDisabled" v-model="formData.psychologicalNursing">
                    <el-checkbox label="1">疏导</el-checkbox>
                    <el-checkbox label="2">沟通</el-checkbox>
                    <el-checkbox label="3">安慰</el-checkbox>
                    <el-checkbox label="4">解释</el-checkbox>
                    <el-checkbox label="5">家属支持</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="2.饮食：">
                <el-checkbox-group :disabled="thirdDisabled" v-model="formData.diet">
                    <el-checkbox label="1">禁食</el-checkbox>
                    <el-checkbox label="2">流质</el-checkbox>
                    <el-checkbox label="3">半流质</el-checkbox>
                    <el-checkbox label="4">普饭</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="3.体位：">
                <el-checkbox-group :disabled="thirdDisabled" v-model="formData.position">
                    <el-checkbox label="1">平卧位</el-checkbox>
                    <el-checkbox label="2">半卧位</el-checkbox>
                    <el-checkbox label="3">肢体抬高位</el-checkbox>
                    <el-checkbox label="4">其他</el-checkbox>
                    <el-input :disabled="thirdDisabled" v-model.trim="formData.positionOther" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="4.切口：">
                <el-checkbox-group :disabled="thirdDisabled" v-model="formData.incision">
                    <el-checkbox label="1">加强观察</el-checkbox>
                    <el-checkbox label="2">保持清洁干燥</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="5.导管：">
                <el-checkbox-group :disabled="thirdDisabled" v-model="formData.conduit">
                    <el-checkbox label="1">加强观察</el-checkbox>
                    <el-checkbox label="2">妥善固定</el-checkbox>
                    <el-checkbox label="3">有效引流</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="6.宣教：">
                <el-checkbox-group :disabled="thirdDisabled" v-model="formData.propagandaEducation">
                    <el-checkbox label="1">饮食</el-checkbox>
                    <el-checkbox label="2">切口</el-checkbox>
                    <el-checkbox label="3">导管</el-checkbox>
                    <el-checkbox label="4">其他</el-checkbox>
                    <el-input :disabled="thirdDisabled" v-model.trim="formData.propagandaEducationOther" style="width:150px;margin:0 5px;" placeholder="请输入"></el-input>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="护士签名：">
                <el-input disabled v-model.trim="formData.nurseName" style="width:60%;" placeholder="请输入签名"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
export default {
    props: ['formData', 'thirdDisabled'],
    data() {
        return {

        }
    },
    watch: {
        $route(to, from) {
            if (this.activatedFlag) {
                this.init()
                // this.query(this.filters.pagination.page);
            }
        },
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.formData.nurseName = this.formData.postoperativeNurseName
        }
    },
}
</script>
<style scoped>
.third {
  border: 1px solid #eee;
  border-radius: 4px;
  margin-top: 10px;
  background: #eee;
}
.people {
  margin-right: 20px;
}
.timeForm {
  display: flex;
}
.third >>> .el-form-item__label {
  line-height: 40px;
}
.third >>> .el-form-item {
  margin-bottom: 0px !important;
}
</style>


